'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { getUsageTracker } from '../../../tracking/usageTracker';
import { EVENTS, ACTIONS } from '../../../tracking/events';
import { memoizedRetrieveSchema } from '../utils/schemaUtils';
import { memoizedGetDefaultFormState } from '../utils/defaults';
import SchemaField from './fields/SchemaField';
import validateFormData, { toErrorList } from '../utils/validate';
import { toIdSchema } from '../utils/idUtils';
import { jsx as _jsx } from "react/jsx-runtime";
class ParamForm extends Component {
  constructor(props) {
    super(props);
    this.onChange = (formData, newErrorSchema) => {
      const {
        liveValidate,
        noValidate
      } = this.props;
      const mustValidate = !noValidate && liveValidate;
      let state = {
        formData
      };
      if (mustValidate) {
        const {
          errors,
          errorSchema
        } = this.validate(formData);
        state = Object.assign({}, state, {
          errors,
          errorSchema
        });
      } else if (!noValidate && newErrorSchema) {
        state = Object.assign({}, state, {
          errorSchema: newErrorSchema,
          errors: toErrorList(newErrorSchema)
        });
      }
      this.tracker.track(EVENTS.PARAM_FORM_INTERACTION, {
        action: ACTIONS.MODIFY_FIELD_VALUE,
        paramType: this.props.schemaGroup
      });
      this.setState(state, () => {
        if (this.props.onChange) {
          this.props.onChange(state);
        }
      });
    };
    this.state = this.getState();
    this.tracker = getUsageTracker();
  }
  getState() {
    const state = this.state || {};
    const {
      liveValidate,
      noValidate,
      schema
    } = this.props;
    const edit = typeof this.props.formData !== 'undefined';
    const mustValidate = edit && !noValidate && liveValidate;
    const {
      definitions
    } = schema;
    const formData = memoizedGetDefaultFormState(schema, this.props.formData, definitions);
    const {
      errors,
      errorSchema
    } = mustValidate ? this.validate(formData, schema) : {
      errors: state.errors || [],
      errorSchema: state.errorSchema || {}
    };
    return {
      errors,
      errorSchema,
      formData
    };
  }
  getIdSchema() {
    const {
      schema
    } = this.props;
    const {
      definitions
    } = schema;
    const retrievedSchema = memoizedRetrieveSchema(schema, definitions, this.state.formData);
    const idSchema = toIdSchema(retrievedSchema, null, definitions, this.state.formData, this.props.idPrefix);
    return idSchema;
  }
  getRegistry() {
    return {
      definitions: this.props.schema.definitions || {},
      formContext: this.props.formContext || {}
    };
  }
  validate(formData, schema = this.props.schema) {
    const {
      definitions
    } = this.getRegistry();
    const resolvedSchema = memoizedRetrieveSchema(schema, definitions, formData);
    return validateFormData(formData, resolvedSchema);
  }
  render() {
    const {
      idPrefix,
      schema,
      schemaGroup
    } = this.props;
    const {
      formData,
      errorSchema
    } = this.state;
    const registry = this.getRegistry();
    const idSchema = this.getIdSchema();
    return /*#__PURE__*/_jsx(SchemaField, {
      errorSchema: errorSchema,
      formData: formData,
      idPrefix: idPrefix,
      idSchema: idSchema,
      onChange: this.onChange,
      registry: registry,
      schema: schema,
      schemaGroup: schemaGroup
    });
  }
}
ParamForm.propTypes = {
  idPrefix: PropTypes.string,
  formContext: PropTypes.object,
  formData: PropTypes.any,
  liveValidate: PropTypes.bool,
  noValidate: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string
};
ParamForm.defaultProps = {
  liveValidate: false,
  noValidate: false
};
export default ParamForm;